import { env } from './environment-types';

export const environment = env({
	name: 'stage',
});
